"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandableRow = void 0;
const react_1 = __importStar(require("react"));
const Icons_1 = require("../icon/Icons");
const TableRow_1 = require("./TableRow");
const TableCell_1 = require("../tableCell/TableCell");
const CustomUtils_1 = require("../utils/CustomUtils");
const ThemeProvider_1 = require("../../styles/ThemeProvider");
const IconCell = (0, ThemeProvider_1.styled)(TableCell_1.TableCell)(() => ({
    padding: '0px 16px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '52px',
}));
const ExpandableRow = (props) => {
    const { rowProps, rowContent, children, onClickExpand } = props, rest = __rest(props, ["rowProps", "rowContent", "children", "onClickExpand"]);
    const [isRowOpen, setIsRowOpen] = (0, react_1.useState)(false);
    const handleExpandRow = (e) => {
        setIsRowOpen((value) => !value);
        onClickExpand === null || onClickExpand === void 0 ? void 0 : onClickExpand(e);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(TableRow_1.TableRow, Object.assign({}, rest, { hover: true, onClick: handleExpandRow }),
            children,
            react_1.default.createElement(IconCell, null, isRowOpen ? react_1.default.createElement(Icons_1.KeyboardArrowUp, null) : react_1.default.createElement(Icons_1.KeyboardArrowDown, null))),
        react_1.default.createElement(TableRow_1.TableRow, Object.assign({}, rowProps),
            react_1.default.createElement(TableCell_1.TableCell, { padding: "none", colSpan: 100, sx: [!isRowOpen && { borderBottom: 'none' }] },
                react_1.default.createElement(CustomUtils_1.CollapseWithName, { "data-testid": "expandableRowContent", in: isRowOpen, unmountOnExit: true }, rowContent)))));
};
exports.ExpandableRow = ExpandableRow;
//# sourceMappingURL=TableRowExpandable.js.map